import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import { IngredientUnit, TempIngredientUnit } from '@/api/types'
import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { Select } from '@/components/Select'

type OptionType = {
  value: any
  label: any
}

type MeasurementUnit = TempIngredientUnit | IngredientUnit

type Props = {
  item: MeasurementUnit
  units: MeasurementUnit[]
  availableUnits: OptionType[]
  isDisabled?: boolean
  onRemove: (idUnit: number) => void
  onUpdate: (item: MeasurementUnit) => void
}

export default function ServingSizeItem({
  item,
  availableUnits,
  isDisabled,
  units,
  onUpdate,
  onRemove,
}: Props) {
  const [tempUnit, setTempUnit] = useState(item)
  const { t } = useTranslation()
  const isNew = tempUnit.name === undefined

  const handleUpdate = () => {
    if (tempUnit.name === undefined || tempUnit.quantityInGrams <= 0) {
      return
    }

    onUpdate(tempUnit)
  }

  const handleUpdateUnit = (item: OptionType) => {
    setTempUnit({ ...tempUnit, name: item.value })
  }

  const handleUpdateQuantity = (value: string) => {
    setTempUnit({ ...tempUnit, quantityInGrams: parseInt(value) })
  }

  return (
    <div className="ServingSizes-grid">
      <Select
        isDisabled={isDisabled}
        options={availableUnits}
        value={{
          value: tempUnit.name,
          label: isNew ? undefined : t(`measurementUnits.${tempUnit.name}` as any),
        }}
        onChange={handleUpdateUnit}
        onBlur={handleUpdate}
        getOptionValue={(option) => option.value}
        getOptionLabel={(option) => option.label}
        isOptionDisabled={(item) => {
          return units.some((unit) => unit.name === item.value)
        }}
        components={{
          IndicatorSeparator: null,
        }}
        classNames={{
          control: () => 'ServingSizes-SelectControl',
          indicatorsContainer: () => 'ServingSizes-indicatorsContainer',
        }}
        styles={{
          input: (baseStyles) => ({
            ...baseStyles,
            paddingBlock: 0,
          }),
        }}
      />
      <Input
        disabled={isDisabled}
        value={tempUnit.quantityInGrams}
        size="small"
        type="number"
        onChange={(item) => handleUpdateQuantity(item.target.value)}
        onBlur={handleUpdate}
      />

      {!isDisabled && (
        <>
          {tempUnit.idUnit === undefined ? (
            <Button variant="icon" style={{ padding: 0 }}>
              <div className="ServingSizes-addButton">
                <FontAwesomeIcon icon={faCheck} color="#7E9626" width={10} height={10} />
              </div>
            </Button>
          ) : (
            <Button variant="icon" onPress={() => onRemove(item.idUnit)} style={{ padding: 0 }}>
              <div className="ServingSizes-deleteButton">
                <FontAwesomeIcon icon={faTrashAlt} color="var(--invalid-color)" size="sm" />
              </div>
            </Button>
          )}
        </>
      )}
    </div>
  )
}
